import { render, staticRenderFns } from "./xtggxiangqing.vue?vue&type=template&id=2da8eab0&scoped=true"
import script from "./xtggxiangqing.vue?vue&type=script&lang=js"
export * from "./xtggxiangqing.vue?vue&type=script&lang=js"
import style0 from "./xtggxiangqing.vue?vue&type=style&index=0&id=2da8eab0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da8eab0",
  null
  
)

export default component.exports